/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EntityFieldTypes {
	Text = "Text",
	TextArea = "TextArea",
	Number = "Number",
	Radio = "Radio",
	RadioInline = "RadioInline",
	Checkbox = "Checkbox",
	CheckboxInline = "CheckboxInline",
	SingleSelect = "SingleSelect",
	MultiSelect = "MultiSelect",
	DatePicker = "DatePicker",
	MunicipalitySelect = "MunicipalitySelect",
	PostalCodeSelect = "PostalCodeSelect",
	AddressBlock = "AddressBlock",
	ClassificationInformationsMultiselect = "ClassificationInformationsMultiselect",
	ClassificationInformationsTreeMultiselect = "ClassificationInformationsTreeMultiselect",
	Switch = "Switch",
	PartyMultiselect = "PartyMultiselect",
	PersonMultiselect = "PersonMultiselect",
	PartyPersonMultiselect = "PartyPersonMultiselect",
	DateTimePicker = "DateTimePicker",
	ActivityTimeField = "ActivityTimeField",
	ActivityDescriptionField = "ActivityDescriptionField",
	ActivityVisibilityField = "ActivityVisibilityField",
	RichText = "RichText",
	PersonTypesField = "PersonTypesField",
}
